module.exports = __webpack_public_path__ + "static/img/1_5_1.931098b8.jpg";